var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},[_c('span',{staticClass:"pb-7"},[_vm._v("К сожалению, запись к врачу временно осуществляется по телефону:")]),_c('div',{staticClass:"d-flex flex-row"},[_c('v-icon',{attrs:{"color":"#8DCDC1"}},[_vm._v("$phone")]),_c('span',{staticClass:"pl-6"},[_vm._v("49-03-49")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }